module.exports = __webpack_public_path__ + "static/media/em-96.6cf43074.png";